<template>
  <div class="m-dataview-container">
    <div class="bg-pic" v-show="showEchart">
    </div>

    <!-- 数据可视化页面 -->
    <div class="dataview-content" v-show="showEchart">
      <!-- 顶部搜索区域 -->
      <div class="top-section">
        <h1 class="title">华艺数资查询</h1>
        <div class="search-box">
          <input type="text" placeholder="请输入商品ID/交易哈希进行搜索" v-model="searchQuery" />
          <search @click="handleSearch" class="search-icon" theme="outline" size="20" fill="#8c9198" />
        </div>
      </div>

      <!-- 数据卡片区域 -->
      <div class="cards-container">
        <div class="data-card">
          <div class="card-number">{{ displayNumbers.totalWorks }}</div>
          <div class="card-label">华艺链作品总数</div>
        </div>
        <div class="data-card">
          <div class="card-number">{{ displayNumbers.totalAssets }}</div>
          <div class="card-label">数字资产总数</div>
        </div>
        <div class="data-card">
          <div class="card-number">{{ displayNumbers.totalAccounts }}</div>
          <div class="card-label">账户总数</div>
        </div>
      </div>

      <!-- 图表区域 -->
      <div class="chart-container">
        <div class="chart-header">
          <span class="chart-tag" :class="{ active: currentTag === 'works' }"
              @click="switchTag('works')">链上作品总数</span>
          <span class="chart-tag-separator">/</span>
          <span class="chart-tag" :class="{ active: currentTag === 'assets' }"
              @click="switchTag('assets')">数字资产总数</span>
          <span class="chart-tag-separator">/</span>
          <span class="chart-tag" :class="{ active: currentTag === 'accounts' }"
              @click="switchTag('accounts')">账户总数</span>
        </div>

        <div class="chart-wrapper">
          <!-- Y轴刻度 -->
          <div class="y-axis">
            <div class="y-tick" style="top: 0;">15000</div>
            <div class="y-tick" style="top: 60px;">12000</div>
            <div class="y-tick" style="top: 120px;">9000</div>
            <div class="y-tick" style="top: 180px;">6000</div>
            <div class="y-tick" style="top: 240px;">3000</div>
            <div class="y-tick" style="top: 300px;">0</div>
          </div>

          <!-- 图表主体 -->
          <div class="chart-main">
            <svg class="line-chart" viewBox="0 0 1000 300" preserveAspectRatio="none">
              <!-- 网格线 -->
              <g class="grid-lines">
                <line x1="0" y1="0" x2="1000" y2="0" />
                <line x1="0" y1="60" x2="1000" y2="60" />
                <line x1="0" y1="120" x2="1000" y2="120" />
                <line x1="0" y1="180" x2="1000" y2="180" />
                <line x1="0" y1="240" x2="1000" y2="240" />
                <line x1="0" y1="300" x2="1000" y2="300" />
              </g>

              <!-- 折线图路径 -->
              <path class="line" :d="currentChartData.path" />

              <!-- 填充区域 -->
              <path class="fill" :d="currentChartData.fillPath" />

              <!-- 触摸时的标记点 -->
              <g v-if="showTooltip" class="tooltip-group">
                <line class="tooltip-line" :x1="tooltipPosition.x" :y1="0" :x2="tooltipPosition.x"
                    :y2="300" />
                <circle class="tooltip-point" :cx="tooltipPosition.x" :cy="tooltipPosition.y" r="5" />
              </g>
            </svg>

            <!-- HTML Tooltip -->
            <div v-if="showTooltip" class="html-tooltip" :style="{
                left: (currentTooltipIndex === chartPoints[currentTag].length - 1)
                    ? `calc(${5 + (currentTooltipIndex / (xAxisTicks.length - 1)) * 90}% - 100px)` // 最后一天在左侧
                    : `calc(${5 + (currentTooltipIndex / (xAxisTicks.length - 1)) * 90}% + 15px)`, // 其他天在右侧
                top: (tooltipPosition.y - 80) + 'px'
            }">
              <div class="tooltip-date">{{ currentTooltipDate }}</div>
              <div class="tooltip-count">{{ currentTooltipValue }}个</div>
            </div>

            <!-- X轴刻度 -->
            <div class="x-axis">
              <div class="x-tick" v-for="(tick, index) in xAxisTicks" :key="index"
                  :style="{ left: getTickPosition(index) }" @click="handleTickClick(index)">
                {{ tick }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 引入搜索结果组件 -->
    <m-search-result
      v-if="!showEchart"
      :search-data="searchData"
      @switch-to-charts="switchToCharts"
    />

    <!-- 自定义弹窗 -->
    <div class="custom-alert-overlay" v-if="showAlert">
      <div class="custom-alert">
        <div class="alert-content">{{ alertMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import getEcharts from '@/api/getEcharts.js'
import getCertificate from '@/api/getCertificate.js'
import { Search } from '@icon-park/vue'
import mSearchResult from './mDataSearch.vue'  // 引入新组件

export default {
  name: 'mDataView',
  components: {
    Search,
    mSearchResult  // 注册新组件
  },
  data () {
    return {
      showEchart: true,
      searchQuery: '',
      searchData: null,
      displayNumbers: {
        totalWorks: 0,
        totalAssets: 0,
        totalAccounts: 0
      },
      actualNumbers: {
        totalWorks: 0,
        totalAssets: 0,
        totalAccounts: 0
      },
      currentTag: 'works',
      xAxisTicks: [],
      chartData: {
        works: { path: '', fillPath: '' },
        assets: { path: '', fillPath: '' },
        accounts: { path: '', fillPath: '' }
      },
      chartPoints: {
        works: [],
        assets: [],
        accounts: []
      },
      showTooltip: false,
      tooltipPosition: { x: 0, y: 0 },
      currentTooltipValue: 0,
      currentTooltipDate: '',
      currentTooltipIndex: -1,
      showAlert: false,
      alertMessage: ''
    }
  },
  computed: {
    currentChartData () {
      return this.chartData[this.currentTag] || { path: '', fillPath: '' }
    }
  },
  mounted () {
    this.fetchEchartsData()
  },
  methods: {
    // 搜索功能
    async handleSearch () {
      try {
        if (!this.searchQuery.trim()) {
          this.showCustomAlert('搜索内容不能为空')
          return
        }

        const response = await getCertificate(this.searchQuery.trim())
        if (!response || response.length === 0) {
          this.showCustomAlert('搜索结果为空')
          return
        }

        this.searchData = response
        this.showEchart = false
      } catch (error) {
        console.error('搜索请求失败:', error)
        this.showCustomAlert('搜索失败，请稍后重试')
      }
    },

    // 切换到图表页面
    switchToCharts () {
      console.log('切换到图表页面');

      this.showEchart = true
    },

    // 获取图表数据
    async fetchEchartsData () {
      try {
        const response = await getEcharts()
        console.log(response)
        const data = response || {}

        this.actualNumbers = {
          totalWorks: data.articlesTotal || 0,
          totalAssets: data.articlesQukTotal || 0,
          totalAccounts: data.userTotal || 0
        }

        // 处理图表数据（使用移动端专用数据，如果没有则使用PC端数据）
        this.processChartData('works', data.mzhexian || data.pczhexian || [])
        this.processChartData('assets', data.mShuzizhexian || data.pcShuzizhexian || [])
        this.processChartData('accounts', data.mUserzhexian || data.pcUserzhexian || [])

        // 开始数字动画
        this.startNumberAnimation()
      } catch (error) {
        console.error('获取图表数据失败:', error)
        // 使用默认值
        this.actualNumbers = {
          totalWorks: 0,
          totalAssets: 0,
          totalAccounts: 0
        }
        this.processChartData('works', [])
        this.processChartData('assets', [])
        this.processChartData('accounts', [])
      }
    },

    // 计算x轴刻度位置
    getTickPosition (index) {
      if (this.xAxisTicks.length <= 1) {
        return '50%' // 单个刻度居中显示
      }
      // 调整为5%到95%之间分布，避免最后一个刻度被截断
      return `${5 + (index / (this.xAxisTicks.length - 1)) * 90}%`
    },

    // 处理x轴刻度点击事件
    handleTickClick (index) {
      // 根据当前标签获取对应的数据点
      const points = this.chartPoints[this.currentTag]
      if (points && points[index]) {
        const point = points[index]
        this.tooltipPosition = {
          x: point.x, // 直接使用原始x坐标，不需要转换
          y: point.y // 直接使用原始y坐标，不需要转换
        }
        this.currentTooltipValue = point.count || 0
        this.currentTooltipDate = this.formatDateLabel(point.date)
        this.currentTooltipIndex = index // 设置当前索引
        this.showTooltip = true

        // 3秒后自动隐藏
        setTimeout(() => {
          this.showTooltip = false
        }, 3000)
      }
    },

    // 处理图表数据
    processChartData (tag, realData) {
      // 只保留最近7天的数据
      const sevenDaysAgo = new Date()
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

      // 过滤出最近7天的数据
      const filteredData = realData.filter(item => {
        if (!item.date) return false
        const itemDate = new Date(item.date)
        return itemDate >= sevenDaysAgo
      })

      // 如果过滤后数据不足，从原始数据末尾取最后7条记录
      let finalData = filteredData
      if (filteredData.length < 7 && realData.length > 0) {
        finalData = realData.slice(-7)
      }

      const points = []
      const totalWidth = 1000
      const pointCount = finalData.length || 7  // 最少显示7个点
      const maxValue = 15000
      const chartHeight = 300

      // 生成x轴刻度，显示所有7个日期
      const ticks = []
      for (let i = 0; i < pointCount; i++) {
        if (finalData[i]) {
          const dataPoint = finalData[i]
          if (dataPoint.date) {
            const dateParts = dataPoint.date.split('-')
            if (dateParts.length >= 3) {
              ticks.push(`${dateParts[1]}-${dateParts[2]}`)
            } else {
              ticks.push('')
            }
          } else {
            ticks.push('')
          }
        } else {
          ticks.push('')
        }
      }

      this.xAxisTicks = ticks

      // 计算每个点的位置（基于过滤后的数据）
      for (let i = 0; i < pointCount; i++) {
        const dataPoint = finalData[i] || { date: '', count: 0 }
        const x = (i / (pointCount - 1)) * totalWidth
        const y = chartHeight - (Math.min(dataPoint.count || 0, maxValue) / maxValue) * chartHeight
        points.push({ x, y, date: dataPoint.date, count: dataPoint.count })
      }

      this.chartPoints[tag] = points

      // 生成路径
      let path = ''
      let fillPath = ''

      if (points.length > 0) {
        // 路径
        path = `M ${points[0].x},${points[0].y}`
        for (let i = 1; i < points.length; i++) {
          const prev = points[i - 1]
          const curr = points[i]
          const cpx1 = prev.x + (curr.x - prev.x) / 2
          const cpy1 = prev.y
          const cpx2 = curr.x - (curr.x - prev.x) / 2
          const cpy2 = curr.y
          path += ` C ${cpx1},${cpy1} ${cpx2},${cpy2} ${curr.x},${curr.y}`
        }

        // 填充路径
        fillPath = path
        fillPath += ` L ${points[points.length - 1].x},${chartHeight} L ${points[0].x},${chartHeight} Z`
      }

      this.chartData[tag] = { path, fillPath }
    },

    // 开始数字动画
    startNumberAnimation () {
      this.animateNumber('totalWorks', this.actualNumbers.totalWorks)
      this.animateNumber('totalAssets', this.actualNumbers.totalAssets)
      this.animateNumber('totalAccounts', this.actualNumbers.totalAccounts)
    },

    // 数字动画
    animateNumber (property, targetValue) {
      const startTime = Date.now()
      const duration = 2000 // 2秒动画
      const startValue = this.displayNumbers[property]

      const updateNumber = () => {
        const elapsed = Date.now() - startTime
        const progress = Math.min(elapsed / duration, 1)

        // 使用缓动函数
        const easeProgress = this.easeOutCubic(progress)

        const currentValue = Math.floor(startValue + (targetValue - startValue) * easeProgress)
        this.$set(this.displayNumbers, property, currentValue)

        if (progress < 1) {
          requestAnimationFrame(updateNumber)
        }
      }

      requestAnimationFrame(updateNumber)
    },

    // 缓动函数
    easeOutCubic (t) {
      return 1 - Math.pow(1 - t, 3)
    },

    // 切换标签
    switchTag (tag) {
      this.currentTag = tag
    },

    // 格式化日期标签
    formatDateLabel (dateString) {
      if (!dateString) return '--'
      const date = new Date(dateString)
      return `${date.getMonth() + 1}-${date.getDate()}`
    },

    // 显示自定义弹窗
    showCustomAlert (message) {
      this.alertMessage = message
      this.showAlert = true
      setTimeout(() => {
        this.showAlert = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/css/mDataview.less';
</style>